import React from 'react';
import {
  VideoCameraIcon,
  CalendarIcon,
  CurrencyDollarIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';

interface FeatureCardProps {
  featureName: string;
  title: string;
  intro: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  featureName,
  title,
  intro,
}) => {
  const iconClassName = 'w-6 h-6';

  const getIcon = () => {
    switch (featureName) {
      case 'oneToOne':
        return <VideoCameraIcon className={iconClassName} />;
      case 'fitSchedule':
        return <CalendarIcon className={iconClassName} />;
      case 'affordable':
        return <CurrencyDollarIcon className={iconClassName} />;
      case 'certifiedTutors':
        return <ShieldCheckIcon className={iconClassName} />;
      default:
        return null;
    }
  };

  return (
    <div className="bg-[#f8f5f0] rounded-lg p-6 h-full transition-all duration-200 hover:bg-[#f3efe9]">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#fbe4dc] flex items-center justify-center text-[#e55425]">
          {getIcon()}
        </div>
        <div className="flex-1">
          <h4 className="font-serif text-lg font-medium text-[#1c1c1c] mb-2 leading-snug">
            {title}
          </h4>
          <p className="text-[15px] text-[#1c1c1c]/65 leading-relaxed">
            {intro}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;
